module.exports = __webpack_public_path__ + "img/logo_Optimo_ovalo.e4a18141.png";